import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { Topbar, Sidebar, Heading, FormInput, Button } from "../../../components";
import { authStaff, staffRoles } from '../../../utils/constants';
import { fetchRequests } from '../../../Requests/getRequests';
import { show } from '../../../slices/toastSlice';

function Create() {

    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [first_name, setFirst_Name] = useState("");
    const [last_name, setLast_Name] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [process, setProcess] = useState(false);

    useEffect(() => {
        const loadRoles = async() => {
            let headers = authStaff(accessToken);
            let res = await fetchRequests(`/auth/roles/`, "GET", headers, {}, {});
            if (!res?.err) setRoleList(res || []);
        }
        loadRoles();
    }, [accessToken])

    const createRequest = async(e) => {
        e.preventDefault();
        setProcess(true);

        let headers = authStaff(accessToken);
        let data = {
            surname: last_name,
            otherNames: first_name,
            phone,
            email,
        }

        let res = await fetchRequests(`/auth/staff/addStaff`, "POST", headers, {}, data);
        setProcess(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: `Your session has expired. Please login to continue.` }));
            return;
        }

        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: `${res?.err}` }));
            return;
        }

        // assign role if selected
        if (selectedRole && res?._id) {
            const roleObj = roleList.find(r => r.slug === selectedRole);
            if (roleObj) {
                await fetchRequests(`/auth/roles/assign`, "POST", headers, {}, {
                    staffId: res._id,
                    roleIds: [roleObj._id]
                });
            }
        }

        dispatch(show({ type: "success", state: true, message: `New staff added successfully` }));
        setTimeout(() => { navigate("/admin/staff") }, 1500);
    }

    return (
        <div className='main-container'>
            <Topbar />
            <Sidebar />

            <main className='main-content'>
                <section className='section-container'>
                    <div className='flex items-center justify-between mb-3'>
                        <Heading
                            text={"Create Staff"}
                            size="text-3xl font-bold tracking-tight text-gray-700"
                        />
                    </div>

                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900">Profile</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    This will add a new staff member's details to the database to allow account creation.
                                </p>
                            </div>
                        </div>

                        <div className="mt-5 md:col-span-2 md:mt-0">
                            <form id="create-staff">
                                <div className="shadow sm:overflow-hidden sm:rounded-md">
                                    <div className="space-y-6 bg-white px-4 py-5 sm:p-6">
                                        <div className="grid grid-cols-2 gap-6">
                                            <FormInput
                                                label="First Name"
                                                name="first_name"
                                                id="first_name"
                                                type={"text"}
                                                required
                                                value={first_name}
                                                setValue={setFirst_Name}
                                            />

                                            <FormInput
                                                label="Last Name"
                                                name="last_name"
                                                id="last_name"
                                                type={"text"}
                                                required
                                                value={last_name}
                                                setValue={setLast_Name}
                                            />

                                            <FormInput
                                                label="Email Address"
                                                name="email"
                                                id="email"
                                                type={"email"}
                                                required
                                                value={email}
                                                setValue={setEmail}
                                            />

                                            <FormInput
                                                label="Phone Number"
                                                name="phone"
                                                id="phone"
                                                type={"number"}
                                                required
                                                value={phone}
                                                setValue={setPhone}
                                            />

                                            <div className="col-span-2">
                                                <label htmlFor="role" className='form-label'>Role (optional):</label>
                                                <select
                                                    id="role"
                                                    name="role"
                                                    className="form-select mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                                                    value={selectedRole}
                                                    onChange={e => setSelectedRole(e.target.value)}
                                                >
                                                    <option value="">-- Select a role --</option>
                                                    {roleList.map((role, i) => (
                                                        <option key={i} value={role.slug}>
                                                            {staffRoles(role.slug)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 px-4 py-3 text-right sm:px-6 space-x-4">
                                        <Link to="/admin/staff" className="cancel-button">
                                            Cancel
                                        </Link>

                                        <Button
                                            btnType={"submit"}
                                            btnClasses={"default-button"}
                                            btnText="Add Staff"
                                            btnFunction={createRequest}
                                            processing={process}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </section>

            </main>

        </div>
    )
}

export default Create
